import {Box, Stack} from "@mui/material";
import {CAMPAIGN_STATUSES, statusLabels} from "../../../project/campaigns/constants";

// Flat tinted pill per status (no borders, no filled MUI chip) — matches the ScorePill pattern
// used in message annotations.
export const statusTints = {
  NOT_CALLED: {bg: "#F2F2F7", color: "#6B6B80"},
  QUEUED: {bg: "rgba(132, 145, 247, 0.12)", color: "#4B55C9"},
  SKIPPED: {bg: "#F2F2F7", color: "#6B6B80"},
  ACTIVE: {bg: "#EAF3FC", color: "#2D6FB0"},
  ANSWERED: {bg: "#E8F7EF", color: "#1E8A55"},
  DECLINED: {bg: "#F1EDFB", color: "#6B46C1"},
  NOT_ANSWERING: {bg: "#FDF4E3", color: "#A86A0C"},
  FAILED: {bg: "#FDECEC", color: "#C73A3A"},
};

const StatusPill = ({status, label, selected, onClick}) => {
  const tint = statusTints[status] || statusTints.NOT_CALLED;
  return (
    <Box
      component={onClick ? "button" : "span"}
      onClick={onClick}
      sx={{
        border: "none", cursor: onClick ? "pointer" : "default", fontWeight: 700, fontSize: 11,
        letterSpacing: "0.02em", height: 24, px: 1, borderRadius: "999px", whiteSpace: "nowrap",
        display: "inline-flex", alignItems: "center",
        bgcolor: tint.bg, color: tint.color,
        ...(onClick && selected ? {boxShadow: `inset 0 0 0 1.5px ${tint.color}`} : {}),
      }}
    >
      {label}
    </Box>
  );
};

// Status counts; pass `onSelect` to use the chips as a status filter
export const CampaignStatusChipsNew = ({statusCounts, selected, onSelect, statuses = CAMPAIGN_STATUSES}) => (
  <Stack direction="row" gap={0.5} flexWrap="wrap">
    {statuses.map(status => (
      <StatusPill
        key={status}
        status={status}
        label={`${statusLabels[status]}: ${statusCounts?.[status] ?? 0}`}
        selected={selected === status}
        onClick={onSelect ? () => onSelect(selected === status ? null : status) : undefined}
      />
    ))}
  </Stack>
);

export const CallStatusChipNew = ({status}) => (
  <StatusPill status={status} label={statusLabels[status] || status || "-"}/>
);
